// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const CourseReserves = ($route: any) => ({
   replace: true,
   templateUrl: '/assets/courseReserves/courseReserves.html',

   link(scope: any){
      scope.routeAction = $route.current.action
      return scope.$on('$routeChangeSuccess', () => {
         return scope.routeAction = $route.current.action
      })
   }
})

const CourseReservesView = () => ({
   replace: true,
   templateUrl: '/assets/courseReserves/courseReservesView.html',
   controller: 'CourseReservesCtrl'
})

const CourseReservesSearchBox = () => ({
   replace: true,
   templateUrl: '/assets/courseReserves/courseReservesSearchBox.html',
   controller: 'CourseReservesCtrl'
})

const CourseReserveDetail = () => ({
   replace: true,
   templateUrl: '/assets/courseReserves/courseReserveDetail.html',
   controller: 'CourseReservesCtrl'
})

const CourseReserveList = () => ({
   scope: {
      reserves: '=',
      courseReserveSearch: '&'
   },

   replace: true,
   templateUrl: '/assets/courseReserves/courseReserveList.html',

   link(scope: any) {

      const nullToEmpty = (s: any) => {
         if (typeof s === 'undefined') {
            return ''
         }
         if (s.toLowerCase() === 'null') { 
            return ''
         }

         return s
      }

      const getFirstInstructor = (i: any) => {
         if (i) {
            const iSplit = i.split(';')
            if (iSplit.length > 1) {
               return iSplit[0].trim()
            } else {
               return i
            }
         }
      }
  
      const createDisplayText = (course: any) => {
         const codeAndSeparator = course.code ? course.code + " : " : ""
         const instructorsAndSeparator = course.instructors ? ' | ' + course.instructors : ""
         return `${codeAndSeparator}${course.name}${instructorsAndSeparator}`
      }

      const courses = []
      for (var c of (scope.reserves || [])) {
         var splitCourse = c.split("||")
         var course = {}
         var instructors = nullToEmpty(splitCourse[3])
         // @ts-expect-error TS(2339) FIXME: Property 'code' does not exist on type '{}'.
         course.code = nullToEmpty(splitCourse[1])
         // @ts-expect-error TS(2339) FIXME: Property 'name' does not exist on type '{}'.
         course.name = nullToEmpty(splitCourse[2])
         // @ts-expect-error TS(2339) FIXME: Property 'instructors' does not exist on type '{}'... Remove this comment to see the full error message
         course.instructors = instructors
         // @ts-expect-error TS(2339) FIXME: Property 'instructor' does not exist on type '{}'.
         course.instructor = getFirstInstructor(instructors)
         // @ts-expect-error TS(2339) FIXME: Property 'display' does not exist on type '{}'.
         course.display = createDisplayText(course)
    
         courses.push(course)
      }
      return scope.courses = courses
   }
})


angular.module('summonApp.directives')
   .directive('courseReserves', ['$route', '$routeParams', CourseReserves])
   .directive('courseReservesView', CourseReservesView)
   .directive('courseReserveDetail', CourseReserveDetail)
   .directive('courseReservesSearchBox', CourseReservesSearchBox)
   .directive('courseReserveList', CourseReserveList)

